import '@styles/Sidebar.css'
import { componentScope } from '../lib/cssScope'
import { SidebarNavContent } from './SidebarNavContent'
import { DefendSphereAiLauncher } from './defendsphere-ai'

export default function Sidebar() {
  return (
    <aside className={`${componentScope('Sidebar')} ds-sidebar`}>
      <div className="ds-sidebar__inner">
        <SidebarNavContent />
      </div>
      <DefendSphereAiLauncher placement="sidebar" />
    </aside>
  )
}
